/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R6Inputs */



/**
* | output |
* | --- |
* | "R6 Same relative pos" |
*
* @param {Rounds_R6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r6 = /** @type {((inputs?: Rounds_R6Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R6Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R6 Même position relative")
	if (locale === "es") return /** @type {LocalizedString} */ ("R6 Misma pos. relativa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R6 Mesma posição relativa")
	if (locale === "it") return /** @type {LocalizedString} */ ("R6 Stessa pos. relativa")
	return /** @type {LocalizedString} */ ("R6 Same relative pos")
});